import React, { useState } from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { getPlatform } from '../constants/stores'
import StoreBadges from './StoreBadges'
import DownloadQR from './DownloadQR'
import Reveal from './Reveal'

function FinalCTA() {
  const { t } = useLocale()
  const [platform] = useState(getPlatform)

  return (
    <section className="section final-cta-section">
      <div className="container">
        <Reveal className="final-cta">
          <img className="final-cta-logo" src="/assets/logo_no_bg.svg" alt="" width="56" height="56" />
          <h2>{t.finalCta.title}</h2>
          <p className="lead">{t.finalCta.lead}</p>
          <div className="final-cta-actions">
            <StoreBadges />
            {platform === 'desktop' && <DownloadQR />}
          </div>
        </Reveal>
      </div>
    </section>
  )
}

export default FinalCTA
